import React, {useCallback, useEffect, useState} from 'react';
import style from './style.module.scss';
import { IHandlers, IProps } from './types';
import {Tooltip} from '@material-ui/core';
import {renderIf} from "external-services/react-utils-service/index";
import classNames from "classnames";
import IconsService from "external-services/icons-service/icons.service";
import UtilsService from "external-services/utils-service/index";

const NS = 'TagIcon';
interface Props {
  className: any,
  title: any,
  onMouseEnter?: any,
}
export default function TagIcon({name, title, icon, iconType, colour, isInverted, children, customerId, hasCustomerNotes, getCustomerInfo, isGrey}: IProps & IHandlers & {children?: any}) {

  /**
   * payment icon size are incoherent with other icons, need this workaround to render the svg correctly as CSS background and FloorPlan svg tag
   */
  const templateHeight = icon === 'payment' ? 38 : 14;
  const maskStyles = `url(images/tags/${icon}.svg) no-repeat 0 0/14px ${templateHeight}px`;
  const [message, setMessage] = useState('');
  const [cachedTitle, setCachedTitle] = useState<string>(title); // initial value comes in as blank hence it doesnt renders data again - so we need to set the data on load of title
  const [titleRes, setTitleRes] = useState<string>();

  let iconStyles: any = {};
  const iconWrapStyles: any = {};

  let MaterialIcon: any;
  if (iconType) {
    MaterialIcon = IconsService.getIcon(iconType);

    if (colour && !isInverted) {
      iconStyles.fill = colour;
    }
  } else {
    iconStyles = {
      WebkitMask: maskStyles,
      mask: maskStyles,
    };
    if (colour && !isInverted) {
      iconStyles.backgroundColor = colour;
    }
  }

  if (isInverted && colour) {
    iconWrapStyles.backgroundColor = colour;
  }

  const IconWrap = () => (
    <span className={classNames({
      [style.iconWrapIsInverted]: isInverted
    })} style={iconWrapStyles}>
      {renderIf(icon, () => (
        <span className={classNames({
          [style.icon]: true,
          [style.iconIsInverted]: isInverted,
          [style.iconIsGrey]: isGrey
        })} style={iconStyles} />
      ))}
      {renderIf(MaterialIcon, () => (
        <MaterialIcon className={classNames({
          [style.matIcon]: true,
          [style.matIconIsInverted]: isInverted
        })} style={iconStyles} />
      ))}
    </span>
  );
  // Request customer notes from backend when mouse hover it.
  const requestNotes = async () => {
    // Get customer from backend
    const customer = await getCustomerInfo(customerId);
    if (customer.notes && (customer.notes as string).length > 0) {
      // not first time request backend
      if (message.includes("Customer Notes:")) {
        const messagePart = message.split("Customer Notes:\n")
        // customer updated, notes not same, then replace it.
        if (customer.notes !== messagePart[1]) {
          setMessage(messagePart[0] + "Customer Notes:" + "\n" + customer.notes)
        }
        // first time request backend
      } else {
        // booking notes is not empty
        if (title && title.length > 0) {
          setMessage( "Customer Notes:" + "\n" + customer.notes);
          // booking notes is empty
        } else {
          setMessage("Customer Notes:" + "\n" + customer.notes)
        }
      }
    } else {
      setMessage('');
    }
  }

  const cachedRequestNotes = useCallback(requestNotes, []);

  // setting the cachedTitle once the title is loaded - https://nowbookit.atlassian.net/browse/NBI-6991
  useEffect(() => {
    if (title) {
      setCachedTitle(title)
    }
  }, [title])


  useEffect(() => {
    const _titleRes: string = (cachedTitle && message && hasCustomerNotes ? (cachedTitle + "\n\n") : cachedTitle) + (hasCustomerNotes ? message : '');
    if (_titleRes === 'undefined') {
      setTitleRes('');
    } else {
      setTitleRes(UtilsService.htmlDecode(_titleRes, true));
    }
  }, [cachedTitle, message, hasCustomerNotes]);

  const props:Props = {
    className: classNames(
      {[style.root]: true, [style.rootIsBirthdayIcon]: icon === 'birthday', [style.rootIsInvertedIcon]: isInverted}
    ),
    title: titleRes || ""
  }
  if (getCustomerInfo && customerId && hasCustomerNotes) {
    props.onMouseEnter = () => cachedRequestNotes();
  }

  return (
    <div {...props}>

      {renderIf(children, () => children)}

      {renderIf(name, () => (
        <Tooltip title={name} placement="top">
          <span className={classNames({
            [style.tooltipFallback]: !icon && !iconType
          })}>
            <IconWrap />
          </span>
        </Tooltip>
      ), () => (
        <IconWrap />
      ))}
    </div>
  )
}

